import React, { useState, useEffect } from "react";
import {Row, Container, Col, Form } from "react-bootstrap";
import TeamBox from "./TeamBox";


export default function Team(props) {

  return (
    <Container fluid className="p-0 pb-5 pt-4 mt-2 trim-padding px-4">
      <Row className="pt-2 pl-4 pr-4 trim-padding pb-2 m-0">
        <Col className="reduce-padding" style={{ backgroundColor: "#EEEEEE", paddingLeft:"23px" }}>
          <Row className="mb-5">
            <Col xs={12} md={10} style={{paddingLeft: "40px"}}>
            <h2 className="mb-2 pt-4 pb-2 section-header">Team Access</h2>
            <p className="primary">
              Team access is a mutually-viewable tool by the client and the
              team, that is for tracking the platforms that the team has been
              granted acess to. In other words, the goal/use of this section is
              exclusively to track and reference in DataPulse, and checking a
              box will <strong>not</strong> automatically grant access.{/* Access
               must be granted by the client on the platform itself. Click 'Show
              me' for a detailed walkthrough of how to grant the team access to
              each platform.*/} Only after you have granted access to your team on 
              the platform should you check and fill the appropriate box in this
              section.
            </p>
            </Col>
          </Row>
          <Col>
            <div className="row mt-3 mb-2 pl-4">
              <h3>General</h3>
            </div>
          </Col>
          <div className="row pl-2 ">
            <Col className="small-box m-0 mr-2 p-0 first-box mb-2">
              <TeamBox title="Shopify" teamAccess={props.client_account.team_access} />
            </Col>
            <Col className="small-box m-0 mr-2 p-0 mb-2">
              <TeamBox title="Google Analytics" teamAccess={props.client_account.team_access}/>
            </Col>
            <Col className="small-box m-0 mr-2 last-box  mb-2">
              
            </Col>
          </div>
          <Col>
            <div className="row mt-3 mb-2 pl-4">
              <h3 style={{ color: "#3291C1" }}>PPC</h3>
            </div>
          </Col>
          <div className="row pl-2">
            <Col className="small-box m-0 mr-2 p-0 first-box mb-2">
              <TeamBox title="Google Ads" teamAccess={props.client_account.team_access}/>
            </Col>
            <Col className="small-box m-0 mr-2 p-0 mb-2">
              <TeamBox title="Microsoft Ads" teamAccess={props.client_account.team_access}/>
            </Col>
            <Col className="small-box m-0 mr-2 p-0 mb-2">
              <TeamBox title="Google Merchant" teamAccess={props.client_account.team_access}/>
            </Col>
          </div>
          <div className="row pl-2">
            <Col className="small-box m-0 mr-2 p-0 first-box mb-2">
              <TeamBox title="DataFeedWatch App" teamAccess={props.client_account.team_access}/>
            </Col>
            <Col className="small-box m-0 mr-2 p-0 mb-2">
              <TeamBox title="Facebook Ads" teamAccess={props.client_account.team_access}/>
            </Col>
            <Col className="small-box m-0 mr-2 p-0 mb-2">
              <TeamBox title="Tiktok Ads" teamAccess={props.client_account.team_access}/>
            </Col>
          </div>
          <div className="row pl-2">
            <Col className="small-box m-0 mr-2 p-0 first-box mb-2">
              <TeamBox title="Youtube" teamAccess={props.client_account.team_access}/>
            </Col>
            <Col className="small-box m-0 mr-2 last-box  mb-2"></Col>
            <Col className="small-box m-0 mr-2 last-box  mb-2"></Col>
          </div>
          <Col>
            <div className="row mt-3 mb-2 pl-4">
              <h3 style={{ color: "#42BA96" }}> SEO</h3>
            </div>
          </Col>
          <div className="row pl-2 mb-2 pb-5 ">
            <Col className="small-box m-0 mr-2 p-0 first-box mb-2">
              <TeamBox title="Google Search Console" teamAccess={props.client_account.team_access} />
            </Col>
            <Col className="small-box m-0 mr-2 p-0 mb-2">
              <TeamBox title="Google Business" teamAccess={props.client_account.team_access}/>
            </Col>
            <Col className="small-box m-0 mr-2 p-0 mb-2" >
              <TeamBox title="SEMRush" teamAccess={props.client_account.team_access}/>
            </Col>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
